import { create } from 'zustand';

/**
 * UI/tool state for the gum-edit phase (bridge scan bays before tooth
 * selection) and the arch-following gum trim in the post-segmentation review.
 */
interface GumEditState {
  /** Number of border vertices currently selected in the bridge step (0–2). */
  selectedCount: number;
  setSelectedCount: (count: number) => void;

  /** Gum collar width around the teeth (mm) for the review trim; null = untouched. */
  trimMargin: number | null;
  setTrimMargin: (margin: number | null) => void;

  /** True while a mesh operation (fill/trim) runs. */
  busy: boolean;
  setBusy: (busy: boolean) => void;

  reset: () => void;
}

export const gumEditStore = create<GumEditState>((set) => ({
  selectedCount: 0,
  setSelectedCount: (selectedCount) => set({ selectedCount }),
  trimMargin: null,
  setTrimMargin: (trimMargin) => set({ trimMargin }),
  busy: false,
  setBusy: (busy) => set({ busy }),
  reset: () => set({ selectedCount: 0, trimMargin: null, busy: false }),
}));
